module.exports = __webpack_public_path__ + "assets/img/mecha-ea18b1c9.png";